var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div><div><auto-query-header query=\"$ctrl.container.query\" search=\"true\" add-button-label=\"New Ticket\" on-toggle-left-nav=\"$ctrl.query.toggleLeftNav()\" on-add=\"$ctrl.create()\"></auto-query-header></div><div class=\"row m-t-1\"><ticket-list-table></ticket-list-table><auto-query-footer ng-model=\"$ctrl.container.query\"></auto-query-footer></div></div>";
var id1="ticket-list.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;